import retry from '@blockcatio/tabby-library/lib/utilities/retry';

import { catFeeUpdated, catFeeUpdateFailed } from '../actions/app';
import { APP_INIT } from '../actionTypes';

/**
 * Responsible for fetching the CAT fee
 *
 * @param {Object} services
 * @param {Object} actions
 *
 * @returns {function}
 */
export default ({ tabbyRewards }) => ({ dispatch }) => next => async (action) => {
  next(action);

  if (action.type === APP_INIT) {
    try {
      const fee = await retry(() => tabbyRewards.fetchCatFee());
      dispatch(catFeeUpdated(fee));
    } catch (error) {
      dispatch(catFeeUpdateFailed(error));
    }
  }
};



// WEBPACK FOOTER //
// ./src/middleware/updateCatFee.js